// extracted by mini-css-extract-plugin
module.exports = {"buttonWithoutPriceWrapper":"ConsumablesFormSubmitButton_buttonWithoutPriceWrapper__k28hE","buttonWithPriceWrapper":"ConsumablesFormSubmitButton_buttonWithPriceWrapper__9DFu0"};